// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ComingSoon_coming-soon__SEA-7 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 40px 24px;
  text-align: center;
}
.ComingSoon_coming-soon__icon__kgR2U {
  font-size: 64px;
  margin-bottom: 24px;
  animation: ComingSoon_bounce__MEUoO 2s infinite;
}
.ComingSoon_coming-soon__title__mS4l4 {
  font-size: 28px;
  font-weight: 700;
  color: var(--text-1, #1a1a2e);
  margin: 0 0 12px 0;
}
.ComingSoon_coming-soon__desc__BSyhc {
  font-size: 16px;
  color: var(--text-2, #666);
  max-width: 400px;
  line-height: 1.6;
}

@keyframes ComingSoon_bounce__MEUoO {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/ComingSoon/ComingSoon.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AACF;AACE;EACE,eAAA;EACA,mBAAA;EACA,+CAAA;AACJ;AAEE;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;AAAJ;AAGE;EACE,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;AADJ;;AAKA;EACE;IAAW,wBAAA;EADX;EAEA;IAAM,4BAAA;EACN;AACF","sourcesContent":[".coming-soon {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n  padding: 40px 24px;\n  text-align: center;\n\n  &__icon {\n    font-size: 64px;\n    margin-bottom: 24px;\n    animation: bounce 2s infinite;\n  }\n\n  &__title {\n    font-size: 28px;\n    font-weight: 700;\n    color: var(--text-1, #1a1a2e);\n    margin: 0 0 12px 0;\n  }\n\n  &__desc {\n    font-size: 16px;\n    color: var(--text-2, #666);\n    max-width: 400px;\n    line-height: 1.6;\n  }\n}\n\n@keyframes bounce {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-10px); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"coming-soon": `ComingSoon_coming-soon__SEA-7`,
	"coming-soon__icon": `ComingSoon_coming-soon__icon__kgR2U`,
	"bounce": `ComingSoon_bounce__MEUoO`,
	"coming-soon__title": `ComingSoon_coming-soon__title__mS4l4`,
	"coming-soon__desc": `ComingSoon_coming-soon__desc__BSyhc`
};
export default ___CSS_LOADER_EXPORT___;
